// Vendor JS
import Debug from 'debug';

// Custom JS
import Optin from '../common/optin';
import Nav from '../common/Nav';
// import PublicationActivity from '../common/publication-activity';
import CigNotify from '../common/notification';
import Sidebar from "../common/sidebar";
// import getGeoLocation from "../util/geoLocation";
import addModalHandler from '../common/modal-logo';

/* eslint-disable no-new */ // Allow using the new keyword while not assigning the class to a variable

/**
 * Fires on all pages
 */
export default {
	/**
	 * JavaScript to be fired on all pages
	 */
	init() {
		try {
			Debug(`cig:info:sage:route:common`)(`init start`);

			// Only run if notification bar exists
			CigNotify.init();

			/* Optin methods */
			new Optin();

			/* Nav Class */
			new Nav();

			// Log when a user visits a publication
			// new PublicationActivity();

			/**
			 * Don't instantiate the Sidebar class if body classes contain "no-sidebar"
			 */
			if (document.body.className.indexOf('no-sidebar') === -1) {
				new Sidebar();
			}

			// TODO: move this logic to it's own file
			/** Search submit buttons */
			const headerSearchSubmitHandler = () => {
				const submitButtons = document.querySelectorAll('#header-search .icon.search');

				submitButtons.forEach((button) => {
					button.addEventListener('click', () => {
						button.closest('form').submit();
					});
				});

				const elForm = document.querySelector('#header-search-form');

				elForm.addEventListener('submit', event => {
					event.preventDefault();

					const elSubmittedForm = event.target;
					const elSearchInput = elSubmittedForm.querySelector('#header-search-input');
					const searchUrl = elSubmittedForm.getAttribute('action') || '/search/';

					window.location = `${searchUrl}?s=${elSearchInput.value}`;
				});
			};

			headerSearchSubmitHandler();

			// TODO: move this logic to it's own file
			/** Initialize Cookie Consent */
			// const setCookieConsent = async () => {
			// 	const userGeoLocation = await getGeoLocation();
			//
			// 	if (userGeoLocation && userGeoLocation.continent && userGeoLocation.continent.code !== 'NA') {
			// 		cookieconsent.initialise({
			// 			palette: {
			// 				popup: {
			// 					background: "#237afc"
			// 				},
			// 				button: {
			// 					background: "#fff",
			// 					text: "#237afc"
			// 				}
			// 			},
			// 			content: {
			// 				href: "https://www.investingdaily.com/cookie-policy/"
			// 			}
			// 		});
			// 	}
			// };
			//
			// setCookieConsent();

			// show logo on payment update modal
			addModalHandler();

		} catch (err) {
			Debug(`cig:error:sage:route:common`)(`Common Route init Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	},

	// Fires after init
	finalize() {
		try {
			Debug(`cig:info:sage:route:common`)(`finalize start`);

		} catch (err) {
			Debug(`cig:error:sage:route:common`)(`Common Route finalize Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	}
};
